import IntegrationStatusBadge from 'features/Integrations/components/IntegrationStatusBadge';

export default function NewStatusBadge({ status }: { status: string }) {
  return <IntegrationStatusBadge status={status} />;
}
